import { ClientEnvironment } from '@thehubz/client/core';
import { CustomClients, CustomClientsTitle } from '@thehubz/shared/branding';
import { termsAndConditions } from './terms-and-conditions';

export const environment: Partial<ClientEnvironment> = {
  production: false,

  // eslint-disable-next-line @typescript-eslint/no-var-requires
  appVersion: require('../../../../../../package.json').version,
  appTitle: '',
  environment: 'DEV',

  brandingKey: CustomClients.WestLotto,
  brandingTitle: CustomClientsTitle.WestLotto,
  apiBasePath: 'https://eurojackpot.test.serviceplanmakeos.com',
  fileAccessUrl: 'https://eurojackpot.test.serviceplanmakeos.com/api/file-access',
  s3Config: {
    bucket: 'makeos-westlotto-test-assets',
  },
  idleTimeout: 60,
  termsConditionsPopup: {
    onAssetDownload: true,
    content: termsAndConditions,
    linkText: $localize`die Gültigkeit der Assets und die Nutzungsbedingungen*`,
  },
  footerPages: {
    showFooter: true,
  },
  assetDownload: {
    excludeFormat: ['gen-thumbnail', 'gen-preview', 'gen-preview-xl', 'pdf-preview', 'gen-convert'],
  },
};
